import { Link } from 'react-router-dom';

const LEGAL_LINKS: { label: string; to: string }[] = [
  { label: 'DOT #', to: '/dot' },
  { label: 'FMCSA Registered', to: '/fmcsa' },
  { label: 'Privacy Policy', to: '/privacy' },
  { label: 'Terms & Conditions', to: '/terms' },
];

export function LegalLinks() {
  return (
    <nav className="flex flex-col gap-3 items-start" aria-label="Legal and compliance">
      {LEGAL_LINKS.map(({ label, to }) => (
        <Link
          key={label}
          to={to}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="text-sm text-gray-300 hover:text-white active:text-white transition-colors duration-200 inline-flex items-center w-fit min-h-[44px] py-2 -my-1 justify-start focus:outline-none focus:ring-0"
        >
          {label}
        </Link>
      ))}
    </nav>
  );
}
